export default "__VITE_ASSET__8baf27ae__"